// Dependencies
import axios from 'axios';

// Interceptors
import responseInterceptor from '@nephro/core/axios/interceptors/responseInterceptor';
import tokenInterceptor from '@nephro/core/axios/interceptors/tokenInterceptor';

export class InternalAxiosInstance {
  constructor(config = {}) {
    this.http = axios.create(config);
  }

  instance() {
    this.http.interceptors.request.use((data) => tokenInterceptor(data));

    this.http.interceptors.response.use(responseInterceptor());

    return this.http;
  }
}

export const internalAxiosInstance = new InternalAxiosInstance({
  headers: { 'content-type': 'application/json' }
}).instance();
